import BaseClass from "../BaseClass";

export default class TooltipHandler extends BaseClass {

    constructor(element) {
        super(element);

        this.tooltip = null;
        this.init();
    }

    init() {
        this.tooltip = new bootstrap.Tooltip(this.element, {
            delay: {"show": 100, "hide": 1000}
        });
    }

    destroyListener() {
        if (this.tooltip != null) {
            this.tooltip.dispose();
        }
    }
}